// useGetPrivateDocument.ts
import { useQuery } from "@tanstack/react-query";
import documentApi from "../../api/documentApi";

export const useGetPrivateDocument = (userId?: number, enabled?: boolean) => {
    return useQuery({
        queryKey: ["private-document", userId],
        enabled: !!userId && enabled,
        queryFn: async () => {
            const res = await documentApi.getPrivateDocumentByUserId(userId!);
            return res.data; // ✅ CHỈ RETURN DATA
        },
    });
};
